import * as React from 'react';

function SvgLocation(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 10.57a1.428 1.428 0 100-2.856 1.428 1.428 0 000 2.857z" }),
        React.createElement("path", { fill: "currentColor", d: "M12 2C8.062 2 4.857 5.065 4.857 8.83c0 1.793.818 4.178 2.43 7.088 1.294 2.336 2.792 4.45 3.571 5.5a1.416 1.416 0 002.287 0c.777-1.05 2.276-3.164 3.57-5.5 1.61-2.91 2.427-5.294 2.427-7.088C19.142 5.065 15.938 2 12 2zm0 10a2.856 2.856 0 110-5.713 2.856 2.856 0 010 5.712z" })));
}

export default SvgLocation;
